<template>
  <div>
    <validation-observer ref="materialRules">
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Malzeme Adı"
            label-for="title"
          >
            <validation-provider
              #default="{ errors }"
              name="Malzeme Adı"
              rules="required"
            >
              <b-form-input
                id="title"
                v-model="dataItem.title"
                placeholder="Malzeme Adı"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Miktar"
            label-for="quantity"
          >
            <validation-provider
              #default="{ errors }"
              name="Miktar"
              rules="required"
            >
              <b-form-input
                id="quantity"
                v-model="dataItem.quantity"
                placeholder="Miktar"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Birim"
            label-for="id_units"
          >
            <validation-provider
              #default="{ errors }"
              name="Birim"
              rules="required"
            >
              <v-select
                id="id_units"
                v-model="dataItem.id_units"
                placeholder="Seçin"
                :options="units"
                label="title"
                :reduce="item => item.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
        >
          <b-button
            variant="danger"
            :disabled="submitStatus"
            @click="submitForm"
          >
            <FeatherIcon icon="SaveIcon" />
            Kaydet
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, localize, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BFormGroup, BFormInput, BRow, BCol, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'MaterialForm',
  components: {
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    refreshDataList: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    units() {
      return this.$store.getters['units/getUnits']
    },
    dataItem() {
      return this.$store.getters['serviceMaterials/dataItem']
    },
    saveData() {
      return this.$store.getters['serviceMaterials/dataSaveStatus']
    },
    modalData() {
      return this.$store.getters['serviceMaterials/modalData']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.submitStatus = false
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    localize('tr')
    this.getUnits()
  },
  methods: {
    getUnits() {
      this.$store.dispatch('units/unitsList')
    },
    submitForm() {
      this.$refs.materialRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.dataItem.id_services = this.$route.params.id
          this.$store.dispatch('serviceMaterials/saveData', this.dataItem)
            .then(response => {
              if (response.status) {
                this.refreshDataList()
                this.modalData.status = false
              }
            })
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
